/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */


window.Vue = require('vue').default;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Throught translations in Vue
const _ = require("lodash");  
Vue.prototype.trans = string => _.get(window.i18n, string);
Vue.prototype.globalVariables = window.globalVariables;

Vue.component('add_to_cart', require('./components/products/AddToCart.vue').default);
Vue.component('cart_button', require('./components/products/CartButton.vue').default);
Vue.component('cart_products', require('./components/Cart.vue').default);
Vue.component('add_to_viewed', require('./components/products/AddToViewed.vue').default);
Vue.component('filter_products', require('./components/products/FilterProducts.vue').default);
Vue.component('checkout', require('./components/Checkout.vue').default);
Vue.component('login', require('./components/Login.vue').default);
Vue.component('register', require('./components/Register.vue').default);
Vue.component('cabinet-my-profile', require('./components/client/CabinetMyProfile.vue').default);
Vue.component('viewed_products', require('./components/ViewedProducts.vue').default);
Vue.component('products_flow', require('./components/products/ProductsFlow.vue').default);
Vue.component('products_list_simple', require('./components/products/CategoryProductsListSimple.vue').default);
Vue.component('viewsales_products_list', require('./components/products/ViewsalesProductsList.vue').default);
Vue.component('brand_products_list', require('./components/products/BrandProductsList.vue').default);
Vue.component('subscription_form', require('./components/subscriptions/Form.vue').default);
Vue.component('collection_products_list', require('./components/products/CollectionProductsList.vue').default);
Vue.component('stock_products_list', require('./components/products/StockProductsList.vue').default);
Vue.component('instagram', require('./components/Instagram.vue').default);
Vue.component('single_product', require('./components/products/SingleProduct.vue').default);
Vue.component('read-more', require('./components/inc/ReadMore').default);
// Analytics
Vue.component('analytics_thankyou', require('./components/analytics/ThankYou.js').default);
Vue.component('analytics_product', require('./components/analytics/Product.js').default);
Vue.component('analytics_home', require('./components/analytics/Home.js').default);
// Notifications
Vue.component('notification_rwrb', require('./components/notifications/RoundeWhiteRightBottom.vue').default);
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
import axios from "axios";
window.addEventListener('load', function () {
    if (document.querySelector('#app')) {
        window.allowNextRequest = true;
        const app = new Vue({
            el: '#app',
            store: store,
            mounted() {
              this.get_cart();
              this.get_viewed_products();
            },
            methods: {
              get_cart() {
                axios({
                    method: "post",
                    url: window.globalVariables.locale + "/get_relevant_cart",
                    config: {
                        headers: {
                            'content-type': 'multipart/form-data'
                        }
                    }
                })
                .then(response => {
                  if (response.data.products.length > 0) {
                    this.$store.commit('cart_add', response.data);
                  }
                  window.cartLoaded = true;
                })
                .catch(error => {
                  console.log('Cart load unsuccess.');
                });
              },
              get_viewed_products() {
                axios({
                    method: "post",
                    url: window.globalVariables.locale + "/get_viwed_products",
                    config: {
                        headers: {
                            'content-type': 'multipart/form-data'
                        }
                    }
                })
                .then(response => {
                  if (response.data.length > 0) {
                    this.$store.commit('viewed_products_add', response.data);
                  }
                })
                .catch(error => {
                  console.log('Viewed products load unsuccess.');
                });
              }
            }
        });
    }
});

window.addEventListener('load', function () {
    if (document.querySelector('#analytics')) {
        const analytics = new Vue({
            el: '#analytics'
        });
    }
});







import { Alert } from 'bootstrap';
// Storage
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    cart: {
      products: [],
      data: []
    },
    viewed_products: [],
    user: null,
    user_additional: null,
    newGoodAdded: 0,
    saving: false
  },
  mutations: { //TODO получить один раз корзину
    cart_add(state, data) {
      state.cart = data;
    },
    viewed_products_add(state, data) {
      state.viewed_products = data;
    },
    new_good_added(state, data) {
      if (data == 0) {
        setTimeout(() => {
          state.newGoodAdded = 0;
        }, 4000);
      } else {
        state.newGoodAdded = data;
      }
    },
    cart_saving(state, data) {
      state.saving = data;
    },
    user_data(state, data) {
      state.user = data;
    },
    user_additional_data(state, data) {
      state.user_additional = data;
    }
  }
})